import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('tour', 'el rondín', 'los rondines')

const createTour = (item, options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/tour/create_tour`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				tour: item,
			}),
			successMessage: `Se agregó el rondín correctamente.`,
		})
		showSuccessMessage('Los rondines se registrarón correctamente')
		dispatch({
			type: 'ADD_TOUR',
			response: res.body?.tour ?? res.body,
		})
		return res.body
	}
}

const copyTour = (item, options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/tour/copy_tour`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				tour: item,
			}),
			successMessage: `Se copio el rondín correctamente.`,
		})
		showSuccessMessage('El rondin se copio correctamente')
		dispatch({
			type: 'ADD_TOUR',
			response: res.body?.tour ?? res.body,
		})
		return res.body
	}
}

const updateTour = (item, options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/tour/update_tour`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				tour: item,
			}),
			successMessage: `Se actualizó el rondín correctamente.`,
		})
		showSuccessMessage('Los rondines se actualizaron correctamente')
		dispatch({
			type: 'UPDATE_TOUR',
			response: res.body?.tour ?? res.body,
		})
		return res.body
	}
}

const updateTourDelete = (item, options) => {
	return async (dispatch, getState) => {
		const state = getState()
		console.log('Entroooo')
		console.log( 'item', item)
		const res = await callApi(`/tour/utils/update_tour_delete`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				tour: item,
			}),
			// successMessage: `Se actualizó el rondín correctamente.`,
		})
		// showSuccessMessage('Los rondines se actualizaron correctamente')
		return res.body
	}
}

const inactivateTour = (tour_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/tour/inactivate_tour/${tour_id}`, {
				headers: {
					Authorization: state.app.user.token
				},
				successMessage: 'Se inactivó correctamente el rondín.'
			})

			dispatch({
				type: `LOAD_TOURS`,
				response: res.body,
			})
		} catch (error) {
			
		}
	}
}

export default { ...actions, createTour, updateTour, updateTourDelete, copyTour, inactivateTour }
